import { useState } from 'react';
import { KPICards } from './components/KPICards.js';
import { ROASTrend } from './components/ROASTrend.js';
import { CampaignTable } from './components/CampaignTable.js';
import { StateMap } from './components/StateMap.js';
import { Heatmap } from './components/Heatmap.js';
import { KeywordTable } from './components/KeywordTable.js';
import { IPDSChart } from './components/IPDSChart.js';
import { ClickLog } from './components/ClickLog.js';

type Tab = 'overview' | 'heatmap' | 'keywords' | 'ipds' | 'tracker';

const TABS: { id: Tab; label: string; icon: string }[] = [
  { id: 'overview', label: 'Overview', icon: '📊' },
  { id: 'heatmap', label: 'Heatmap', icon: '🔥' },
  { id: 'keywords', label: 'Keywords', icon: '🔑' },
  { id: 'ipds', label: 'IPDS', icon: '📐' },
  { id: 'tracker', label: 'Tracker', icon: '🔗' },
];

export function MediaBuyerPage() {
  const [activeTab, setActiveTab] = useState<Tab>('overview');

  return (
    <div className="space-y-6 min-h-full">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-slate-100 flex items-center gap-3">
          <span>📊</span> Media Buyer
        </h1>
        <p className="text-zinc-400 mt-1">Google Ads performance, ROAS tracking, and campaign management</p>
      </div>

      {/* Tab Bar */}
      <div className="border-b border-slate-800 -mt-2 overflow-x-auto">
        <nav className="flex gap-1 min-w-max" aria-label="Tabs">
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap
                ${activeTab === tab.id
                  ? 'border-blue-500 text-blue-400'
                  : 'border-transparent text-slate-500 hover:text-slate-300 hover:border-slate-600'
                }
              `}
            >
              <span>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && (
        <div className="space-y-6">
          <KPICards />
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            <ROASTrend />
            <StateMap />
          </div>
          <CampaignTable />
        </div>
      )}

      {activeTab === 'heatmap' && (
        <Heatmap />
      )}

      {activeTab === 'keywords' && (
        <KeywordTable />
      )}

      {activeTab === 'ipds' && (
        <IPDSChart />
      )}

      {activeTab === 'tracker' && (
        <ClickLog />
      )}
    </div>
  );
}
